var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',[_c('div',{staticClass:"label__title"},[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")]):_vm._e()]),(_vm.item)?_c('div',{class:_vm.className},[_vm._v(_vm._s(_vm.item))]):_c('div',{class:_vm.className},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }